<template>
  <!-- 
        导航 
             el-menu   导航主体                 
             el-submenu   - 导航容器项（内部有子菜单）               
             el-menu-item-group   - 导航分组容器（用于将导航项目分组，并命名）   
             el-menu-item  - 最终导航项         
    -->
  <!-- 激活路由 -->
  <el-scrollbar class="scrllbar" style="background: #f6f7fb">
    <el-menu
      @select="handleSelect"
      @open="handleOpen"
      :router="true"
      :default-active="routepath"
      :collapse="isCollapse"
      class="active cursorpointer"
      id="abc"
    >
      <div class="width100 menuitem" @click="tohome()">
        <div :class="activebgindex == 0 ? 'activebg' : ''">
          <img
            :class="activebgindex == 0 ? 'activecorlor' : ''"
            src="@/assets/barsvg/01sy.svg"
            alt=""
          />
          <!-- <span class="pad-left10">首 页</span> -->
        </div>
      </div>
      <!-- 数据检索 -->
      <el-submenu index="/Data-Homepage" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 1 ? 'activebg' : ''">
            <img
              :class="activebgindex == 1 ? 'activecorlor' : ''"
              src="@/assets/barsvg/02sjjs.svg"
              alt=""
            />
            <span class="pad-left10">数据检索</span>
          </div>
        </template>

        <el-menu-item index="/Data-Homepage/Patent-search">
          <template #title>
            <span>专利检索</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/Data-Homepage/Trademark-search">
          <template #title>
            <span>商标检索</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/Data-Homepage/Enterprise-search">
          <template #title>
            <span>企业检索</span>
          </template>
        </el-menu-item>
      </el-submenu>
      <!-- 行业瞭望 -->
      <el-submenu index="/Industry-Outlook" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 2 ? 'activebg' : ''">
            <img
              :class="activebgindex == 2 ? 'activecorlor' : ''"
              src="@/assets/barsvg/03hylw.svg"
              alt=""
            />
            <span class="pad-left10">行业瞭望</span>
          </div>
        </template>

        <el-menu-item index="/Industry-Outlook/Industry-report">
          <template #title>
            <span>产业报告</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/Industry-Outlook/Peer-attention">
          <template #title>
            <span>同行关注</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Industry-Outlook/technology-information">
          <template #title>
            <span>科技资讯</span>
          </template>
        </el-menu-item>
      </el-submenu>

      <!-- 研发管理 -->
      <el-submenu index="/development-Administration" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 3 ? 'activebg' : ''">
            <img
              :class="activebgindex == 3 ? 'activecorlor' : ''"
              src="@/assets/barsvg/04cpyf.svg"
              alt=""
            />
            <span class="pad-left10">产品研发</span>
          </div>
        </template>

        <el-menu-item index="/development-Administration/product-management">
          <template #title>
            <span>产品管理</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/development-Administration/Science-projects">
          <template #title>
            <span>研发项目</span>
          </template>
        </el-menu-item>
        <!-- <el-menu-item index="/development-Administration/Cost-collection">
          <template #title>
            <svg
              style="width: 20px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
            >
              <path
                d="M17.778 3.556c6.873 0 12.444 5.572 12.444 12.444s-5.572 12.444-12.444 12.444c-6.873 0-12.444-5.572-12.444-12.444s5.572-12.444 12.444-12.444zM17.778 5.333c-5.891 0-10.667 4.776-10.667 10.667s4.776 10.667 10.667 10.667c5.891 0 10.667-4.776 10.667-10.667s-4.776-10.667-10.667-10.667zM21.659 9.333c0.425 0.245 0.571 0.789 0.325 1.214l-1.483 2.568h1.948c0.491 0 0.889 0.398 0.889 0.889s-0.398 0.889-0.889 0.889h-3.556v1.778h3.556c0.491 0 0.889 0.398 0.889 0.889s-0.398 0.889-0.889 0.889h-3.556v3.556c0 0.491-0.398 0.889-0.889 0.889s-0.889-0.398-0.889-0.889v-3.556h-3.556c-0.491 0-0.889-0.398-0.889-0.889s0.398-0.889 0.889-0.889h3.556v-1.778h-3.556c-0.491 0-0.889-0.398-0.889-0.889s0.398-0.889 0.889-0.889h1.256l-1.483-2.568c-0.243-0.421-0.103-0.958 0.313-1.207l0.013-0.007c0.421-0.243 0.958-0.103 1.207 0.313l0.007 0.013 1.996 3.457h1.579l1.996-3.457c0.245-0.425 0.789-0.571 1.214-0.325zM5.614 8.093c0.44 0.219 0.619 0.752 0.4 1.192-1.028 2.069-1.57 4.352-1.57 6.716 0 1.738 0.293 3.434 0.86 5.037 0.164 0.463-0.079 0.971-0.542 1.134-0.275 0.097-0.567 0.051-0.792-0.1-0.094-0.059-0.173-0.132-0.238-0.217l-0.002-0.002-2.733-3.623c-0.296-0.392-0.218-0.949 0.174-1.245s0.949-0.218 1.245 0.174l0.323 0.429c-0.047-0.475-0.074-1.027-0.074-1.585 0-0.001 0-0.001 0-0.002v0c0-2.639 0.607-5.194 1.756-7.507 0.218-0.44 0.752-0.619 1.192-0.4z"
              ></path>
            </svg>
            <span class="pad-left10">研发费用</span>
          </template>
        </el-menu-item> -->

        <el-menu-item index="/development-Administration/industrial-design">
          <template #title>
            <span>工业设计</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/development-Administration/Patent-navigation">
          <template #title>
            <span>专利导航</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/development-Administration/Technical-monitoring">
          <template #title>
            <span>技术监控</span>
          </template>
        </el-menu-item>
      </el-submenu>

      <!-- 研发费用 -->
      <el-submenu index="/expenses-money" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 4 ? 'activebg' : ''">
            <img
              :class="activebgindex == 4 ? 'activecorlor' : ''"
              src="@/assets/barsvg/05yffy.svg"
              alt=""
            />
            <span class="pad-left10">研发费用</span>
          </div>
        </template>

        <el-menu-item index="/expenses-money/Cost-collection">
          <template #title>
            <span>费用管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/expenses-money/Financial-collection">
          <template #title>
            <span>财务管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/expenses-money/Payroll-statement">
          <template #title>
            <span>工资报表</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/expenses-money/auxiliary-account">
          <template #title>
            <span>研发辅助账</span>
          </template>
        </el-menu-item>
      </el-submenu>

      <!-- 成果管理 -->
      <el-submenu index="/Results-trading" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 5 ? 'activebg' : ''">
            <img
              :class="activebgindex == 5 ? 'activecorlor' : ''"
              src="@/assets/barsvg/06cggl.svg"
              alt=""
            />
            <span class="pad-left10">成果管理</span>
          </div>
        </template>
        <el-menu-item index="/Results-trading/Results-management">
          <template #title>
            <span>成果管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Results-trading/value-assessment">
          <template #title>
            <span>成果估值</span>
          </template>
        </el-menu-item>
        <!-- <el-menu-item index="/Results-trading/assessment-report">
          <template #title>
            <span>评估报告</span>
          </template>
        </el-menu-item> -->
        <el-menu-item index="/Results-trading/Achievement-entrustment">
          <template #title>
            <span>成果出售</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Results-trading/Achievement-introduction">
          <template #title>
            <span>成果采购</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Results-trading/Project-financing">
          <template #title>
            <span>项目融资</span>
          </template>
        </el-menu-item>
      </el-submenu>

      <!-- 知识产权 -->
      <el-submenu index="/intellectual-property" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 6 ? 'activebg' : ''">
            <img
              :class="activebgindex == 6 ? 'activecorlor' : ''"
              src="@/assets/barsvg/07zscq.svg"
              alt=""
            />
            <span class="pad-left10">知识产权</span>
          </div>
        </template>
        <el-menu-item index="/intellectual-property/Management-patents">
          <template #title>
            <span>专利管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/intellectual-property/Manage-trademarks">
          <template #title>
            <span>商标管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/intellectual-property/Soft-copyright">
          <template #title>
            <span>软著版权</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/intellectual-property/Online-application">
          <template #title>
            <span>在线申请</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/intellectual-property/patent-lookout">
          <template #title>
            <span>专利瞭望台</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/intellectual-property/trademark-lookout">
          <template #title>
            <span>商标瞭望台</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/intellectual-property/Through-rate">
          <template #title>
            <span>商标通过率检测</span>
          </template>
        </el-menu-item>
      </el-submenu>

      <!-- 原创认证 -->
      <el-submenu index="/Original-certification" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 7 ? 'activebg' : ''">
            <img
              :class="activebgindex == 7 ? 'activecorlor' : ''"
              src="@/assets/barsvg/08ycrz.svg"
              alt=""
            />
            <span class="pad-left10">原创认证</span>
          </div>
        </template>
        <el-menu-item index="/Original-certification/Certification-management">
          <template #title>
            <span>认证管理</span>
          </template>
        </el-menu-item>
        <!-- <el-menu-item index="/Original-certification/Application-certification">
          <template #title>
            <span>申请认证</span>
          </template>
        </el-menu-item> -->
      </el-submenu>

      <!-- 科创保镖 -->
      <!-- <el-submenu index="/Kechuang-Bodyguard" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 8 ? 'activebg' : ''">
 <img :class="activebgindex == 8 ? 'activecorlor' : ''" src="@/assets/barsvg/09kcbb.svg" alt="">
            <span class="pad-left10">科创保镖</span>
          </div>
        </template>

        <el-menu-item index="/Kechuang-Bodyguard/Online-warning">
          <template #title>
            <span>在线预警</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/Kechuang-Bodyguard/Deposit-evidence">
          <template #title>
            <span>存证取证</span>
          </template>
        </el-menu-item>
      </el-submenu> -->

      <!-- 科技金融 -->
      <el-submenu index="/technology-finance" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 9 ? 'activebg' : ''">
            <img
              :class="activebgindex == 9 ? 'activecorlor' : ''"
              src="@/assets/barsvg/10kjjr.svg"
              alt=""
            />
            <span class="pad-left10">科技金融</span>
          </div>
        </template>

        <el-menu-item index="/technology-finance/Financing-management">
          <template #title>
            <span>融资管理</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/technology-finance/product-matching">
          <template #title>
            <span>融资产品匹配</span>
          </template>
        </el-menu-item>
      </el-submenu>

      <!-- 政策管家 -->
      <el-submenu index="/Science-technology" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 10 ? 'activebg' : ''">
            <img
              :class="activebgindex == 10 ? 'activecorlor' : ''"
              src="@/assets/barsvg/11zcgj.svg"
              alt=""
            />
            <span class="pad-left10">政策管家</span>
          </div>
        </template>
        <el-menu-item index="/Science-technology/Policy-items">
          <template #title>
            <span>政策列表</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/Science-technology/Policy-subscription">
          <template #title>
            <span>我的订阅</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/Science-technology/Intelligent-matching">
          <template #title>
            <span>智能匹配</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Science-technology/Intelligent-declaration">
          <template #title>
            <span>智能申报</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Science-technology/Policy-Template">
          <template #title>
            <span>政策模板</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Science-technology/Policy-lookout">
          <template #title>
            <span>政策瞭望台</span>
          </template>
        </el-menu-item>
      </el-submenu>

      <!-- 企业管理 -->
      <el-submenu index="/business-management" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 11 ? 'activebg' : ''">
            <img
              :class="activebgindex == 11 ? 'activecorlor' : ''"
              src="@/assets/barsvg/12qygl.svg"
              alt=""
            />
            <span class="pad-left10">企业管理</span>
          </div>
        </template>

        <el-menu-item index="/business-management/Organizational">
          <template #title>
            <span>组织架构管理</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/business-management/Member-Management">
          <template #title>
            <span>成员管理</span>
          </template>
        </el-menu-item>
        <!-- <el-menu-item index="/business-management/Company-Profile">
          <template #title>
            <span>企业简介</span>
          </template>
        </el-menu-item> -->
        <el-menu-item index="/business-management/Digital-assets">
          <template #title>
            <span @click="totrfa()">数字资产</span>
          </template>
        </el-menu-item>
        <!-- <el-menu-item index="/business-management/enterprise-data">
          <template #title>
            <span>企业数据</span>
          </template>
        </el-menu-item> -->
      </el-submenu>

      <!-- 合同管理 -->
      <!-- <el-submenu index="/contract-management" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 12 ? 'activebg' : ''">
            <img
              :class="activebgindex == 12 ? 'activecorlor' : ''"
              src="@/assets/barsvg/13htgl.svg"
              alt=""
            />
            <span class="pad-left10">合同管理</span>
          </div>
        </template>

        <el-menu-item index="/contract-management/Enterprise-contract">
          <template #title>
            <span>企业合同</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/contract-management/Housekeeper-contract">
          <template #title>
            <span>管家合同</span>
          </template>
        </el-menu-item>
      </el-submenu> -->

      <!-- 文件管理 -->
      <el-submenu index="/Enterprise-networkdisk" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 13 ? 'activebg' : ''">
            <img
              :class="activebgindex == 13 ? 'activecorlor' : ''"
              src="@/assets/barsvg/14dayp.svg"
              alt=""
            />
            <span class="pad-left10">档案云盘</span>
          </div>
        </template>

        <el-menu-item index="/Enterprise-networkdisk/file-management">
          <template #title>
            <span>文件管理</span>
          </template>
        </el-menu-item>

        <el-menu-item index="/Enterprise-networkdisk/Permission-Settings">
          <template #title>
            <span>分享管理</span>
          </template>
        </el-menu-item>
      </el-submenu>

      <!-- 个人中心 -->
      <!-- <el-submenu index="/Personal-Center" class="width100 submenu">
        <template #title>
          <div :class="activebgindex == 14 ? 'activebg' : ''">
            <svg
              width="14px"
              height="16px"
              viewBox="0 0 14 16"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              :class="activebgindex == 14 ? 'activecorlor' : ''"
            >
              <path
                d="M6.91539342,-0.0490433061 C8.9507038,-0.0952209734 10.6386513,1.53597431 10.6860596,3.59411799 C10.6809811,4.76464063 10.1154994,5.86144359 9.15757302,6.44803413 C11.4769464,7.30557574 13.0281075,9.52936551 13.0499954,12.0276522 C13.0352973,13.1073409 12.1973181,13.9809176 11.1479437,14.046065 L10.9966611,14.0498072 L3.0040344,14.0498024 C1.88496325,14.0653701 0.965410735,13.159352 0.950001375,12.0266008 C0.968521904,9.52974176 2.5193838,7.30569291 4.82911736,6.53567678 C3.88212395,5.86214458 3.31735466,4.765832 3.31228263,3.59279746 C3.35480971,1.66650914 4.83952785,0.102848198 6.71954779,-0.0394379112 L6.91539342,-0.0490433061 Z M2.13847401,12.0261474 C2.14574976,12.4674455 2.47493327,12.8239463 2.89491485,12.8699008 L3.00166813,12.874789 L10.9973982,12.8745809 C11.4683019,12.8795582 11.8535369,12.500469 11.8598683,12.0283327 C11.7888016,9.4186838 9.71319643,7.32047869 7.13216504,7.24865232 C4.44711255,7.17515775 2.21118286,9.3150573 2.13847401,12.0261474 Z M6.9361502,1.00612469 C5.55651188,1.04086712 4.46635494,2.19917219 4.50074615,3.59487451 C4.51960558,4.91511058 5.55069616,5.98307063 6.83635246,6.05176175 L7.0605109,6.05510542 C8.44046991,6.02035492 9.53029819,4.86342199 9.49592502,3.46856082 C9.46154394,2.07337807 8.31574858,0.971383268 6.9361502,1.00612469 Z"
                id="个人中心"
              ></path>
            </svg>
            <span class="pad-left10">个人中心</span>
          </div>
        </template>
        <el-menu-item index="/Personal-Center/Trademarks-Concern">
          <template #title>
            <span>我关注的商标</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/Trademark-Sharing">
          <template #title>
            <span>我分享的商标</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/Enterprises-Interest">
          <template #title>
            <span>我关注的企业</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/Enterprises-Sharing">
          <template #title>
            <span @click="totrfa()">我分享的企业</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/patent-Interest">
          <template #title>
            <span>我关注的专利</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/patent-Sharing">
          <template #title>
            <span>我分享的专利</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/Enterprise-Certification">
          <template #title>
            <span>企业认证申请</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/joined-enterprise">
          <template #title>
            <span>我加入的企业</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/message-reminds">
          <template #title>
            <span>我的消息提醒</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/reminder-schedule">
          <template #title>
            <span>我的日程提醒</span>
          </template>
        </el-menu-item>
        <el-menu-item index="/Personal-Center/Sharing-Management">
          <template #title>
            <span>文件分享管理</span>
          </template>
        </el-menu-item>
      </el-submenu> -->
    </el-menu>
  </el-scrollbar>
</template>


<script>
import { routes } from "../router/index";
export default {
  data() {
    return {
      routes,
      topscrll: "",
      routepath: "",
      activebgindex: -1,
      isCollapse: true,
    };
  },
  computed: {},
  watch: {
    $route() {
      this.routepath = this.$route.fullPath;
    },
  },
  methods: {
    tohome() {
      this.$router.push({ path: "/home/homepage" });
      // this.activebgindex = 0;
    },
    handleSelect(key, keyPath) {
      if (key != "/Enterprise-networkdisk/file-management ") {
        window.sessionStorage.setItem("doctourlid", 0);
      }
      if (key != "/Data-Homepage/Patent-search") {
        window.sessionStorage.removeItem("query_typep");
        window.sessionStorage.removeItem("titlep");
        window.sessionStorage.removeItem("invetrop");
        window.sessionStorage.removeItem("agencyp");
        window.sessionStorage.removeItem("patenteep");
        window.sessionStorage.removeItem("addressp");
        window.sessionStorage.removeItem("dbp");
        window.sessionStorage.removeItem("ipcp");
        window.sessionStorage.removeItem("app_numberp");
        window.sessionStorage.removeItem("pub_numberp");
      }
      if (key != "/Data-Homepage/Trademark-search") {
        window.sessionStorage.removeItem("query_type");
        window.sessionStorage.removeItem("trademark_name");
        window.sessionStorage.removeItem("agent_name");
        window.sessionStorage.removeItem("register");
        window.sessionStorage.removeItem("addresst");
        window.sessionStorage.removeItem("reg_number");
        window.sessionStorage.removeItem("international_class");
      }
    },
    handleOpen(key, keyPath) {
      if (key == "/Data-Homepage") {
        this.activebgindex = 1;
      } else if (key == "/Industry-Outlook") {
        this.activebgindex = 2;
      } else if (key == "/development-Administration") {
        this.activebgindex = 3;
      } else if (key == "/expenses-money") {
        this.activebgindex = 4;
      } else if (key == "/Results-trading") {
        this.activebgindex = 5;
      } else if (key == "/intellectual-property") {
        this.activebgindex = 6;
      } else if (key == "/Original-certification") {
        this.activebgindex = 7;
      } else if (key == "/Kechuang-Bodyguard") {
        this.activebgindex = 8;
      } else if (key == "/technology-finance") {
        this.activebgindex = 9;
      } else if (key == "/Science-technology") {
        this.activebgindex = 10;
      } else if (key == "/business-management") {
        this.activebgindex = 11;
      } else if (key == "/contract-management") {
        this.activebgindex = 12;
      } else if (key == "/Enterprise-networkdisk") {
        this.activebgindex = 13;
      } else if (key == "/Personal-Center") {
        this.activebgindex = 14;
      }
    },
    totrfa() {
      window.sessionStorage.setItem("trfa", 1);
    },
  },
  created() {
    this.routepath = this.$route.fullPath;
  },
  mounted() {
    // document.querySelector(".GeminiScrollbar").style.height =
    //   document.documentElement.clientHeight - 59 + "px";
  },
};
</script>

<style scoped>
.menuitem {
  width: 60px;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  padding: 0 0 0 20px;
  background: #f6f7fb;
}
.menuitem:hover {
  background: #effcfd;
  color: #52c6cc !important;
}
.el-submenu .el-menu-item {
  height: 60px;
  line-height: 60px;
  color: rgb(191, 203, 217);
  background: #f6f7fb !important;
}
.submenu >>> .el-submenu__title {
  height: 60px;
  /* line-height: 60px; */
  background: #f6f7fb;
  font-size: 14px;
  color: #6a7589 !important;
  /* border-bottom: 1px solid #effcfd; */
}
.submenu >>> .el-submenu__title:hover {
  background: #effcfd;
  color: #52c6cc !important;
}
.el-menu-item,
.el-submenu__title {
  height: 60px;
  /* line-height: 60px; */
  background: #f6f7fb;
  color: #6a7589 !important;
  /* border-bottom: 1px solid #effcfd; */
}

/* .el-menu-item.is-active {
  width: 100%;
  height: 60px;
  line-height: 60px;
  color: #52c6cc !important;
  background: #effcfd !important;
} */
.el-menu-item:hover {
  /* width: 100%;
  height: 60px;
  line-height: 60px; */
  /* margin: 0 10px 0 10px; */
  /* padding-left: 30px !important; */
  /* border-radius: 20px; */
  color: #52c6cc !important;
  background: #effcfd !important;
}
.active {
  max-height: 100px;
}
.active >>> .el-menu {
  background-color: #f6f7fb !important;
}
.activebg {
  width: 40px;
  height: 40px;
  line-height: 40px;
  /* padding: 5px; */
  position: relative;
  top: 10px;
  left: -10px;
  background: #52c6cc;
  border-radius: 50%;
  color: #fff;
}
.activecorlor {
  padding-left: 10px;
  fill: #fff;
}
.el-scrollbar {
  height: 100%;
  margin-bottom: 56px;
}
.fontqr {
  font-size: 40px;
}
.ewm {
  position: relative;
  bottom: -100px;
  left: 0;
  display: flex;
  justify-content: center;
  width: 250px;
  padding: 10px 0 0 0;
}
.iconfont {
  color: #647c97;
}
.itemfont {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  margin-right: 5px;
}
.scrllbar >>> .thumb {
  background: rgb(48, 65, 86);
}
.scrllbar >>> .el-scrollbar__bar.is-vertical > div {
  width: 0;
}
</style>
